<template>
    <div class="modal catalog-request right" id="catalog-request">
        <div class="bg-modal" :class="{show: submitted}" :style="`background-image: url(${this.urlBackground});`"></div>
        <div class="close-button" @click="submitted = false"><span class="icon-cross"></span>Fermer</div>
        <h2 class="titre" v-if="!submitted">Je souhaite recevoir ma brochure</h2>
        <div class="content mCustomScrollbar">
            <!--ScrollBar-->
            <transition mode="out-in">
                <div class="div-anim" v-if="submitted" key="confirmation">
                    <p class="margin"></p>
                    <p class="merci">Merci !</p>
                    <p class="okmsg">Votre demande a bien été prise en compte, vous allez très bientôt pouvoir consulter
                        notre brochure.</p>
                    <a href="#" class="btn chevron outline goback" @click.prevent="close">Retour</a>
                </div>

                <form @submit.prevent="submit" v-else key="formulaire" class="div-anim">


                    <p class="intro field-set">Sélectionnez la ou les brochures que vous souhaitez recevoir chez vous.
                    </p>

                    <div class="send-method field-set flex">
                        <div class="checkbox-wrap">
                            <input type="checkbox"
                                   class="ge"
                                   id="send-by-email"
                                   v-model="form.sendByEmail">
                            <label for="send-by-email">par mail</label>
                            <p v-for="error in errors.get('send_by_email')">{{ error }}</p>
                        </div>

                        <div class="checkbox-wrap">
                            <input type="checkbox"
                                   class="ge"
                                   id="postal"
                                   v-model="form.sendByPost">
                            <label for="postal">par voie postale</label>
                            <p v-for="error in errors.get('send_by_post')">{{ error }}</p>
                        </div>
                    </div>

                    <h3 class="sous-titre">1. Vos coordonnées</h3>
                    <div class="field-set">

                        <custom-select :options="titles"
                                       value-field="value"
                                       v-model="form.title"
                                       class="civility"
                                       required>
                        </custom-select>
                        <p v-for="error in errors.get('title')">{{ error }}</p>

                        <div class="bloc-input row">
                            <div class="col-12 col-lg-6">
                                <div class="form-item">
                                    <label for="last-name">Nom *</label>
                                    <input type="text"
                                           id="last-name"
                                           v-model="form.lastName"
                                           required>
                                </div>
                                <p v-for="error in errors.get('last_name')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="form-item">
                                    <label for="first-name">Prénom *</label>
                                    <input type="text"
                                           id="first-name"
                                           v-model="form.firstName"
                                           required>
                                </div>
                                <p v-for="error in errors.get('first_name')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="form-item">
                                    <label for="email">Email *</label>
                                    <input type="email"
                                           id="email"
                                           v-model="form.email"
                                           required>
                                </div>
                                <p v-for="error in errors.get('email')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="form-item">
                                    <label for="phone-number">Téléphone</label>
                                    <input type="tel"
                                           id="phone-number"
                                           v-model="form.phoneNumber">
                                </div>
                                <p v-for="error in errors.get('phone_number')">{{ error }}</p>
                            </div>

                            <div class="col-12">
                                <div class="form-item textarea">
                                    <label for="address">
                                        Adresse {{ form.sendByPost ? '*' : '' }}
                                    </label>
                                    <textarea id="address"
                                              rows="4"
                                              v-model="form.address"
                                              :required="form.sendByPost"></textarea>
                                </div>
                                <p v-for="error in errors.get('address')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="form-item">
                                    <label for="postalcode">
                                        Code postal {{ form.sendByPost ? '*' : '' }}
                                    </label>
                                    <input type="text"
                                           id="postalcode"
                                           v-model="form.zipCode"
                                           :required="form.sendByPost">
                                </div>
                                <p v-for="error in errors.get('zip_code')">{{ error }}</p>
                            </div>

                            <div class="col-12 col-lg-6">
                                <div class="form-item">
                                    <label for="city">
                                        Ville {{ form.sendByPost ? '*' : '' }}
                                    </label>
                                    <input type="text"
                                           id="city"
                                           v-model="form.city"
                                           :required="form.sendByPost">
                                </div>
                                <p v-for="error in errors.get('city')">{{ error }}</p>
                            </div>
                        </div>
                    </div>

                    <h3 class="sous-titre">2. Quelle(s) brochure(s) souhaitez-vous recevoir ?</h3>
                    <div class="field-set checkbox-catalog">
                        <div class="row">
                            <div class="col-12 col-lg-6" v-for="brochure in brochures">
                                <input type="checkbox"
                                       class="ge"
                                       :id="`brochure_${brochure.id}`"
                                       :value="brochure.id"
                                       v-model="form.brochures">
                                <label :for="`brochure_${brochure.id}`">{{ brochure.name }}</label>
                            </div>
                        </div>
                        <p v-for="error in errors.get('brochures')">{{ error }}</p>
                    </div>

                    <h3 class="sous-titre">3. Vous nous avez connu...</h3>
                    <div class="field-set">
                        <custom-select v-model="form.origin"
                                       :options="origins"
                                       value-field="value"
                                       class="connu"
                                       required>
                        </custom-select>
                        <p v-for="error in errors.get('origin')">{{ error }}</p>
                    </div>

                    <h3 class="sous-titre">4. Newsletter</h3>
                    <div class="field-set">
                        <input type="checkbox"
                               class="ge"
                               id="newsletter"
                               v-model="form.subscribeToNewsletter">
                        <label for="newsletter">Je m’inscris à la newsletter Grands Espaces</label>
                        <p v-for="error in errors.get('subscribe_to_newsletter')">{{ error }}</p>
                    </div>



                    <div class="field-set">
                        <button type="submit" class="btn chevron submit-link">Recevoir ma brochure</button>
                    </div>

                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>

                </form>
            </transition>
        </div>


    </div>
</template>

<script>
    import ajaxForm from '../../mixins/ajaxForm';
    import Modal from '../../libs/Modal';

    export default {
        mixins: [ajaxForm],
        props: {
            brochures: {
                type: Array,
                required: true,
            },
            origins: {
                type: Array,
                required: true,
            },
            urlBackground: {
                type: String,
                required: false,
            },
        },
        data: () => ({
            titles: [
                {
                    label: 'Civilité',
                    value: '',
                },
                {
                    label: 'Madame',
                    value: 'mrs',
                },
                {
                    label: 'Monsieur',
                    value: 'mr',
                },
            ],
            form: {
                sendByEmail: false,
                sendByPost: false,
                title: '',
                origin: '',
                brochures: [],
            },
        }),
        methods: {
            submit() {
                this.request('ge_add_brochure_request', this.mapFields(this.form));
            },
            reset() {
                this.form = {
                    title: '',
                    brochures: [],
                };
            },
            close() {
                this.submitted = false;
                Modal.hideModal('#catalog-request');
            },
        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/brochures/ModalBrochures.vue